var ScaleResult = /** @class */ (function () {
    function ScaleResult() {
        this.score = 0;
    }
    Object.defineProperty(ScaleResult.prototype, "scale", {
        get: function () {
            return this._scale;
        },
        set: function (v) {
            this._scale = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleResult.prototype, "score", {
        get: function () {
            return this._score;
        },
        set: function (v) {
            this._score = v;
        },
        enumerable: true,
        configurable: true
    });
    ScaleResult.prototype.getScoreForDisplay = function () {
        // @see https://stackoverflow.com/a/5623195
        return this._score.toFixed(2).replace(/[.,]00$/, "");
    };
    Object.defineProperty(ScaleResult.prototype, "scorePercentage", {
        get: function () {
            var score = 0;
            if (this.scale && this.score) {
                score = this.scale.getPercentageForScore(this.score);
            }
            return score;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleResult.prototype, "range", {
        get: function () {
            return this._range;
        },
        set: function (v) {
            this._range = v;
        },
        enumerable: true,
        configurable: true
    });
    ScaleResult.prototype.getRangeDisplayName = function () {
        if (this._range) {
            return this._range.displayName;
        }
        return "";
    };
    return ScaleResult;
}());
export { ScaleResult };



// WEBPACK FOOTER //
// ./src/app/shared/models/scale-result.ts.pre-build-optimizer.js